import { useId } from 'react'

const ContactField3D = ({
  id,
  name,
  label,
  type = 'text',
  rows,
  required = false,
  autoComplete,
}) => {
  const generatedId = useId()
  const fieldId = id || generatedId
  const isTextarea = Boolean(rows)

  const sharedProps = {
    id: fieldId,
    name,
    required,
    autoComplete,
    className: 'contact-field-3d-input',
    spellCheck: isTextarea ? true : undefined,
  }

  return (
    <div>
      <label htmlFor={fieldId} className="site-muted mb-2 block">
        {label}
      </label>

      <div className={['contact-field-3d', isTextarea ? 'contact-field-3d--textarea' : ''].join(' ')}>
        {isTextarea ? (
          <textarea
            {...sharedProps}
            rows={rows}
          />
        ) : (
          <input {...sharedProps} type={type} />
        )}
      </div>
    </div>
  )
}

export default ContactField3D
